module.exports = __webpack_public_path__ + "img/main.7f12b775.png";